<template>
  <div class="language-selector-page">
    <div class="d-flex justify-content-between align-items-center mb-0 p-2">
      <h1 class="mb-0">{{ $t('language.title') }}</h1>
    </div>

    <section>
      <div class="d-flex flex-column w-100">
        <div
          v-for="lang in languages"
          :key="lang.code"
          class="language-list-item d-flex align-items-center justify-content-between cursor-pointer"
          @click="changeLanguage(lang.code)"
        >
          <div class="d-flex align-items-center overflow-hidden flex-grow-1">
            <img :src="lang.flag" alt="flag" class="flag-icon">
            <h5 class="mb-0 font-weight-bold text-body text-truncate">
              {{ lang.name }}
            </h5>
          </div>

          <div v-if="$i18n.locale === lang.code" class="flex-shrink-0 text-body">
            <feather-icon icon="CheckIcon" size="22" />
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import flagEn from '@/assets/images/flags/en.png';
import flagCy from '@/assets/images/flags/cy.png';
import * as AuthService from '@/services/AuthService';

export default {
  name: 'LanguageSelector',
  data() {
    return {
      languages: [
        {
          code: 'en',
          name: 'English',
          flag: flagEn,
        },
        {
          code: 'cy',
          name: 'Cymraeg',
          flag: flagCy,
        },
      ],
    };
  },
  computed: {
    userId() {
      return AuthService.getUserId()
    },
  },
  methods: {
    changeLanguage(code) {
      this.$i18n.locale = code;

      if (this.userId) {
        localStorage.setItem(`${this.userId}-language`, code);
      } else {
        localStorage.setItem('userLanguage', code);
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.language-list-item {
  padding: 1rem 1.5rem;
  background-color: transparent;
  border-bottom: 1px solid rgba(128, 128, 128, 0.1);
  transition: all 0.2s ease-in-out;

  &:hover {
    background-color: rgba(0, 0, 0, 0.02);
  }

  &:last-child {
    border-bottom: none;
  }
  .flag-icon {
    width: 30px;
    height: 30px;
    border-radius: 50%;
    object-fit: cover;
    margin-right: 12px;
  }
}

.menu-dark .language-list-item:hover {
  background-color: rgba(255, 255, 255, 0.05);
}
</style>
